import { Box, Slider, Typography } from "@mui/material";
import { styled } from "baseui";
import { Theme } from "baseui/theme";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BriaTooltip from "../../../../../../components/common/BriaTooltip/BriaTooltip";
import { useAppStore } from "../../../../../../hooks/useStores";
import { isBriaMember, isBriaOrg } from "../../../../../../utils";
import crosshairs from "../../../../../assets/svgs/crosshairs.svg";
import { useEditor } from "../../../../../hooks/useEditor";
import { useZoomRatio } from "../../../../../hooks/useZoomRatio";
import styles from "./Graphic.module.scss";
import Scenes from "./Scenes/Scenes";
const Container = styled<"div", {}, Theme>("div", ({ $theme }) => ({
	background: $theme.colors.white,
	marginRight: "8px",
	marginBottom: "8px",
	borderRadius: "8px",
	border: "1px solid #e7e7e7",
	overflowX: "auto",
	overflowY: "hidden",
}));
interface Options {
	zoomRatio: number;
}
export default function () {
	const editor = useEditor();
	const zoomMin = 10;
	const zoomMax = 240;
	const [options, setOptions] = useState<Options>({
		zoomRatio: 50,
	});
	const zoomRatio: number = useZoomRatio();
	const { authStore } = useAppStore();
	const { t } = useTranslation("translation", { keyPrefix: "adsGeneration" });
	let isCustomerViewBannerDisplyed = isBriaMember(authStore.user) && !isBriaOrg();

	useEffect(() => {
		setOptions({ ...options, zoomRatio: Math.round(zoomRatio * 100) });
	}, [zoomRatio]);
	const recenterCanvas = () => {
		const canvas = editor?.canvas.canvas;
		if (canvas) {
			editor?.zoom.zoomToRatio(1);
			canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);
			canvas.requestRenderAll();
		}
	};

	return (
		<>
			<BriaTooltip
				title={t("recenterCanvas")}
				className={clsx({
					[styles.tooltip]: true,
					[styles.customBottomTooltip]: isCustomerViewBannerDisplyed,
				})}
			>
				<img onClick={recenterCanvas} className={styles.crosshairs} src={crosshairs} alt="" />
			</BriaTooltip>
			<Box className={styles.sliderContainer}>
				<Box className={styles.sliderInput}>
					<Slider
						min={zoomMin}
						max={zoomMax}
						defaultValue={50}
						value={Number([options.zoomRatio])}
						onChange={(_event, value) => {
							const zoomValue = value as number;
							if (zoomValue < 0) {
								editor?.zoom.zoomToRatio(zoomMin / 100);
							} else if (zoomValue > zoomMax) {
								editor?.zoom.zoomToRatio(zoomMax / 100);
							} else {
								editor?.zoom.zoomToRatio(zoomValue / 100);
							}
						}}
						className={styles.slider}
					/>
					<Typography className={styles.zoomValueLabel}> {[options.zoomRatio]}%</Typography>
				</Box>
			</Box>
			<Container>
				<Scenes />
				{/* <Common /> */}
			</Container>
		</>
	);
}
